import { SPFxAdalClient, DefaultRuntime, onRuntimeCreate, objectDefinedNotNull } from "@pnp/common";
onRuntimeCreate(function (runtime) {
    var existing = runtime.get("graph");
    var graphPart = Object.assign({}, {
        fetchClientFactory: function () {
            // we keep a ref to the runtime within which we are assigned
            var context = runtime.get("spfxContext");
            if (objectDefinedNotNull(context)) {
                return new SPFxAdalClient(context);
            }
            throw Error("There is no Graph Client available, either set one using configuration or provide a valid SPFx Context.");
        },
    }, existing);
    runtime.assign({ graph: graphPart });
});
export function setup(config, runtime) {
    if (runtime === void 0) { runtime = DefaultRuntime; }
    runtime.assign(config);
}
//# sourceMappingURL=graphlibconfig.js.map